import { render, staticRenderFns } from "./TruckLoad.vue?vue&type=template&id=35a3ab97&scoped=true"
import script from "./TruckLoad.vue?vue&type=script&lang=js"
export * from "./TruckLoad.vue?vue&type=script&lang=js"
import style0 from "./TruckLoad.vue?vue&type=style&index=0&id=35a3ab97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3ab97",
  null
  
)

export default component.exports